"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ExamQuestionStatsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async queryStats(_a) {
        var { date = new Date().toISOString() } = _a, rest = __rest(_a, ["date"]);
        const options = Object.assign({ date }, rest);
        const queryParams = Object.keys(options)
            .map(key => `${key}=${encodeURIComponent(options[key])}`)
            .join('&');
        const url = `${this.url}/api/stats?${queryParams}`;
        const response = await this.requestMaker.makeRequest(url, {
            method: 'GET'
        }, [200]);
        return response.json;
    }
}
exports.default = ExamQuestionStatsServiceClient;
//# sourceMappingURL=ExamQuestionStatsServiceClient.js.map